import { useContext } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
  FilterNonIdeal,
} from "../../../../common";
import { AppPagination, UBButton } from "../../../../../Libraries";
import useTransactionListing from "../../../../../hooks/useTransactionListing";
import useSellVoucherNavigation from "../../../../../hooks/useSellVoucherNavigation";
import VoucherVendorTransactionRow from "./VoucherVendorTransactionRow";
import { LanguageContext } from "../../../../../context/LanguageContext";
import styles from "../../TransactionListing/TransactionListing.module.css";
import walletMainStyles from "../../WalletMain.module.css";

const VOUCHER_TXN_TYPES = ["voucher_payment"];

const VoucherVendorTransactions = () => {
  const [I18n] = useContext(LanguageContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const { goToSellVouchers, isSellVoucherLoading } = useSellVoucherNavigation();

  const customerPhone = state?.customerPhone || null;
  const customerName = state?.customerName || null;
  const company = state?.company || null;
  const vendor_id = state?.vendor_id || null;
  const vendorTransactions = state?.vendorTransactions || null;

  const handleRowClick = (item) => {
    if (item.id) {
      navigate(`/UCash/TransactionDetail/voucher_payment/${item.id}`);
    }
  };

  const { transactions, hasNext, isLoading, isInitialLoading, handleLoadMore } =
    useTransactionListing({
      txnTypes: VOUCHER_TXN_TYPES,
      customerPhone,
      vendor_id,
      initialFilters: { companies: company ? [company] : [] },
      seedData: vendorTransactions,
    });

  const title =
    [customerName, company].filter(Boolean).join(" - ") || I18n.vouchers;

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{ title, isBack: true, onBack: () => navigate(-1), id: "voucher_transaction_vendor", isTitleCase: false }}
          >
            <UBButton
              id="voucher_transaction_vendor_sell_vouchers_btn"
              title={I18n.sell_vouchers}
              loading={isSellVoucherLoading}
              disabled={isSellVoucherLoading}
              className="ubButtonStyle ubPrimaryButton textUppercase fontSize14"
              onClick={() => goToSellVouchers({
                state: {
                  prefilledCustomerPhone: customerPhone,
                  prefilledCustomerName: customerName,
                },
              })}
            />
          </TitleAndActionBox>

          <InnerWrapper className="innerWrapper newInnerWrapper">
            <Box className="invoiceListTableHeader accountTableHeaderMain">
              <Box className="invListTableHeaderCol fourColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">
                  {I18n.date}
                </span>
              </Box>
              <Box className="invListTableHeaderCol fourColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">
                  {I18n.voucher}
                </span>
              </Box>
              <Box className="invListTableHeaderCol fourColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">
                  {I18n.phone_number}
                </span>
              </Box>
              <Box className="invListTableHeaderCol fourColumn textRight">
                <span className="fontSize12 fontWeight500 newLightColor">
                  {I18n.amount}
                </span>
              </Box>
            </Box>

            <Box
              className={`${styles.listWrapper} generic-scrollbar`}
              id="voucherVendorTxnScrollable"
            >
              {isInitialLoading ? (
                <Box
                  className={`${walletMainStyles.transactionListLoadingBox} h-100`}
                >
                  <CircularProgress size={25} />
                </Box>
              ) : transactions.length === 0 ? (
                <Box className="h-100">
                  <FilterNonIdeal
                    title={I18n.no_transactions_found}
                    subTitle={I18n.transactions_will_appear_here_once_available}
                  />
                </Box>
              ) : (
                <AppPagination
                  data={{
                    handleNext: handleLoadMore,
                    pageLoad: isLoading,
                    count: hasNext,
                    list: transactions,
                    scrollableTarget: "voucherVendorTxnScrollable",
                  }}
                >
                  {transactions.map((item, idx) => (
                    <VoucherVendorTransactionRow
                      key={item.id || idx}
                      item={item}
                      onRowClick={handleRowClick}
                    />
                  ))}
                </AppPagination>
              )}
            </Box>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default VoucherVendorTransactions;
